export const enum IconTypes {
  Solid = 'solid',
  Regular = 'regular',
}
export const solidIconPack = 'fas';
export const regularIconPack = 'far';
